import { Inject, Injectable } from '@angular/core';
import { combineLatest, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { NbaBaseResolversCollection } from '../nba-base-resolver-collection';

import { NbaConditionResolver } from './nba-condition-resolver.interface';
import { nbaConditionResolverToken } from './nba-condition-resolver.token';

@Injectable()
export class NbaConditionResolversCollection extends NbaBaseResolversCollection<NbaConditionResolver> {
  public constructor(@Inject(nbaConditionResolverToken) resolvers: NbaConditionResolver[]) {
    super(resolvers);
  }

  public changed$(): Observable<Observable<boolean>> {
    return combineLatest(
      Object.keys(this.resolvers).map(
        (resolverId: string): Observable<boolean> => this.resolvers[resolverId].resolve$()
      )
    ).pipe(map((results: boolean[]) => of(results.some(Boolean))));
  }
}
